export const PromotionTypes = {
    PricePoint: "PricePoint",
    NXM: "NXM",
    ManualDiscountPercentage: "ManualDiscountPercentage",
    ManualDiscountFixed: "ManualDiscountFixed",
    Fidelity: "Fidelity",
    DXQ: "DXQ",
    DiscountForPaymentMethod: "DiscountForPaymentMethod",
    Coupon: "Coupon"
};

export const additionalsWithoutValue = [
    PromotionTypes.Fidelity
];

export const PromotionState = {
    Applied: "Applied",
    Invalid: "Invalid",
    NotCompatible: "NotCompatible",
    CouldBeApplied: "CouldBeApplied"
}
